import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ParadigmaModal from "../../../components/ParadigmaModal/"
import api from "../../../api";

import { Label, Input, FormFeedback, Table } from 'reactstrap';

import ParadigmaAsyncSeeker from "../../../components/ParadigmaAsyncSeeker/ParadigmaAsyncSeeker.js"

class Informe extends Component {
    constructor(props) {
        super(props);
        this.state = {
            emiteinforme: false,
            observacion: "",
            url: "",
            plantillas: [],
            solicitud: null,
            proyecto_codigo: null,
        };
    }

    static propTypes = {
        onSubmit: PropTypes.func.isRequired,
        id: PropTypes.func.isRequired,
    }

    resetState() {
        this.setState({
            emiteinforme: false,
            observacion: "",
            url: "",
            plantillas: [],
            solicitud: null,
            proyecto_codigo: null,
        })
    }

    setSelects(data) {
        this.setState({
            emiteinforme: data.emiteinforme,
            observacion: data.observacion,
            plantillas: data.plantillas,
            url: (data.url != undefined ? api.BASE_URL + data.url : ""),
            solicitud: data.solicitud_id,
            proyecto_codigo: data.codigo,
        });
    }

    render() {

        var atr = [];
        if (this.state.plantillas) {
            for (var i = 0; i < this.state.plantillas.length; i++) {
                var row = this.state.plantillas[i];
                atr.push(
                    <tr key={i}>
                        <td>
                            {row.nombre}
                        </td>
                        <td>
                            <a target={"_blank"} href={row.url}>DESCARGAR</a>
                        </td>
                    </tr>
                );
            }
        }


        return (
            <ParadigmaModal
                fileUploader={true}
                getUrl={api.proyectos.informes.informe}
                postUrl={api.proyectos.informes.informe}
                onSubmit={() => this.props.onSubmit()}
                id={this.props.id}
                successMessage={"La Solicitud ha sido editada con éxito."}
                missingIdMessage={"Debe seleccionar una fila."}
                title={"Carga de Informe"}
                buttonTitle={"Carga de Informe"}
                buttonIcon={"fa fa-file-text fa-lg"}
                notAllowedMessage={"La Solicitud no puede ser editada en esta etapa porque ya fue avanzada."}

                saveButton={true}
                closeButton={true}
                className={"ui-modal-dialog ui-modal-lg"}
                onGotData={(data) => this.setSelects(data)}
                onClose={() => this.resetState()}
            >
                <div className="ui-form">
                    <div className="ui-section-grid">
                        <section className="ui-section-block ui-section-span-2">
                            <p className="ui-section-label">Datos del proyecto</p>
                            <div className="ui-row-1">
                                <div className="ui-field">
                                    <Label>Código</Label>
                                    <ParadigmaAsyncSeeker pkField={"codigo"} nombreField={"cod"} fieldName={""} url={api.proyectos.solicitudes.selectcodigo} value={this.state.proyecto_codigo} disabled={true} />
                                    <FormFeedback />
                                </div>
                            </div>
                            <div className="ui-row-1">
                                <div className="ui-field">
                                    <Label>Proyecto</Label>
                                    <ParadigmaAsyncSeeker fieldName={"solicitud_id"} url={api.proyectos.solicitudes.select} value={this.state.solicitud} disabled={true} />
                                    <FormFeedback />
                                </div>
                            </div>
                        </section>

                        <section className="ui-section-block">
                            <p className="ui-section-label">Emite informe</p>
                            <div className="ui-row-1">
                                <div className="ui-radio-group">
                                    <Label className={"ui-radio-opt"} htmlFor="radio1">
                                        <Input type="radio" id="radio1" name="emiteinforme" value="true"
                                            checked={this.state.emiteinforme === true}
                                            onChange={(e) => this.setState({ emiteinforme: true })}
                                        />
                                        <span className="pl-4">SI</span>
                                    </Label>
                                    <Label className={"ui-radio-opt"} htmlFor="radio2">
                                        <Input type="radio" id="radio2" name="emiteinforme" value="false"
                                            checked={this.state.emiteinforme === false}
                                            onChange={(e) => this.setState({ emiteinforme: false })}
                                        />
                                        <span className="pl-4">NO</span>
                                    </Label>
                                </div>
                            </div>
                            {this.state.emiteinforme && this.state.url != "" &&
                                <div className="ui-row-1">
                                    <a target={"_blank"} href={this.state.url} className="mt-2">
                                        <i className="fa fa-download mt-2"></i> DESCARGAR INFORME
                                    </a>
                                </div>
                            }
                            {this.state.emiteinforme && (
                                <div className="ui-row-1">
                                    <div className="ui-field">
                                        <Label>Archivo{this.state.url && <small className="font-italic"> El informe subido puede ser reemplazado.</small>}</Label>
                                        <Input type="file" multiple name="file"></Input>
                                        <FormFeedback />
                                    </div>
                                </div>
                            )}
                        </section>

                        <section className="ui-section-block">
                            <p className="ui-section-label">Plantillas disponibles</p>
                            <Table className="ui-table table-sm">
                                <thead>
                                    <tr>
                                        <th>Nombre</th>
                                        <th>Acción</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {atr}
                                </tbody>
                            </Table>
                        </section>

                        {this.state.emiteinforme && (
                            <section className="ui-section-block ui-section-span-2 ui-section-compact">
                                <p className="ui-section-label">Observaciones</p>
                                <div className="ui-row-1">
                                    <div className="ui-field">
                                        <Input rows={5} type="textarea" name="observacion" value={this.state.observacion} onChange={(e) => this.setState({ observacion: e.target.value })} />
                                        <FormFeedback />
                                    </div>
                                </div>
                            </section>
                        )}
                    </div>
                </div>
            </ParadigmaModal>
        );
    }
}

export default Informe;



// WEBPACK FOOTER //
// ./src/views/Proyectos/Procedimiento4/Informe.js